import Const from 'const';
import MlbBuilderFactory from 'components/organisms/players-to-exchange/available-players/mlb/builder-factory';
import NbaBuilderFactory from 'components/organisms/players-to-exchange/available-players/nba/builder-factory';
import NflBuilderFactory from 'components/organisms/players-to-exchange/available-players/nfl/builder-factory';
import NhlBuilderFactory from 'components/organisms/players-to-exchange/available-players/nhl/builder-factory';
import CfbBuilderFactory from 'components/organisms/players-to-exchange/available-players/cfb/builder-factory';
import GolfBuilderFactory from 'components/organisms/players-to-exchange/available-players/golf/builder-factory';
import NascarBuilderFactory from 'components/organisms/players-to-exchange/available-players/nascar/builder-factory';
import LolBuilderFactory from 'components/organisms/players-to-exchange/available-players/lol/builder-factory';
import MmaBuilderFactory from 'components/organisms/players-to-exchange/available-players/mma/builder-factory';
import F1BuilderFactory from 'components/organisms/players-to-exchange/available-players/f1/builder-factory';
import TennisBuilderFactory from 'components/organisms/players-to-exchange/available-players/tennis/builder-factory';

export default class AbstractBuilderFactory {
    private static builders = {
        [Const.LEAGUE_CFB]: CfbBuilderFactory,
        [Const.LEAGUE_GOLF]: GolfBuilderFactory,
        [Const.LEAGUE_F1]: F1BuilderFactory,
        [Const.LEAGUE_LOL]: LolBuilderFactory,
        [Const.LEAGUE_MLB]: MlbBuilderFactory,
        [Const.LEAGUE_MMA]: MmaBuilderFactory,
        [Const.LEAGUE_NASCAR]: NascarBuilderFactory,
        [Const.LEAGUE_NBA]: NbaBuilderFactory,
        [Const.LEAGUE_NFL]: NflBuilderFactory,
        [Const.LEAGUE_NHL]: NhlBuilderFactory,
        [Const.LEAGUE_TENNIS]: TennisBuilderFactory,
    };
    public static getBuilder(sport: string) {
        if (sport in AbstractBuilderFactory.builders) {
            return new AbstractBuilderFactory.builders[sport]();
        }

        throw Error('Builder not found. Make sure you are using a valid sport.');
    }
}
